import IField from "./IField";
import FieldFactory from "./Fields/FieldFactory";

export default class Entity {

    public static deserialize(input: any): Entity {
        const fields = input.fields.map(FieldFactory.deserialize)
            .sort((f1: IField, f2: IField) => f1.order - f2.order);
        return new Entity(input.id, input.name, fields);
    }

    public id: string;
    public name: string;
    public fields: IField[];

    /* tslint:disable-next-line:variable-name */
    public readonly __typename: string = "Entity";

    constructor(id: string, name: string, fields: IField[]) {
        this.id = id;
        this.name = name;
        this.fields = fields;
    }
}


// WEBPACK FOOTER //
// ./src/metamodel/Entity.ts